import { Modal } from "antd";
import { useEffect, useRef, useState } from "react";

interface DocumentModalProps {
  documentUrl: string;
  documentTitle: string;
  modalTitle: string;
  children: React.ReactNode;
}

const DocumentModal = ({ documentUrl, documentTitle, modalTitle, children }: DocumentModalProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [iframeKey, setIframeKey] = useState(0);
  const iframeRef = useRef<HTMLIFrameElement | null>(null);
  const timerId = useRef<NodeJS.Timeout | null>(null);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setIframeKey((prev) => prev + 1);
  };

  useEffect(() => {
    if (!isModalOpen) return;

    const reloadIFrame = () => {
      const iframe = iframeRef.current;
      if (!iframe || !iframe.contentDocument) return;

      try {
        const url = iframe.contentDocument.URL;
        console.log("iframe URL check:", url);
        if (url === "about:blank") {
          console.warn("Iframe is blank — reloading...");
          iframe.src = iframe.src;
        }
      } catch (err) {
        console.log("Could not access iframe content:", err);
      }
    };

    timerId.current = setInterval(reloadIFrame, 1000);

    const iframe = iframeRef.current;
    const handleLoad = () => {
      if (timerId.current) {
        clearInterval(timerId.current);
        timerId.current = null;
        console.log("Finally Loaded");
      }
    };

    if (iframe) {
      iframe.addEventListener("load", handleLoad);
    }

    return () => {
      if (timerId.current) clearInterval(timerId.current);
      if (iframe) iframe.removeEventListener("load", handleLoad);
    };
  }, [isModalOpen, iframeKey]);

  return (
    <>
      <span
        onClick={openModal}
        style={{ cursor: "pointer", textDecoration: "underline" }}
      >
        {children}
      </span>

      <Modal
        title={modalTitle}
        open={isModalOpen}
        onCancel={closeModal}
        afterClose={closeModal}
        footer={null}
        width="80%"
        style={{ top: 20 }}
        destroyOnClose
      >
        <iframe
          ref={iframeRef}
          key={iframeKey}
          id="iFrame"
          src={`https://docs.google.com/gview?url=${documentUrl}&embedded=true`}
          style={{ width: "100%", height: "70vh", border: "none" }}
          title={documentTitle}
        />
      </Modal>
    </>
  );
};

export default DocumentModal;